import {createContext,useContext} from 'solid-js';
import { theme } from 'Shared/frontend/SettingsProvider';

const LayoutContext = createContext();

interface ILayoutContent {
	pageName: string;
	setPageName: (name:string)=>void;
	setSettingsPageName: (name:string)=>void,
	setExpandDesktopNav: (expand:boolean)=>void,
	imageFolder: string;
	setImageFolder: (name:string)=>void,
}

export function LayoutProvider(P:{children} & ILayoutContent)
{
	return (
		<LayoutContext.Provider value={P}>
			{P.children}
		</LayoutContext.Provider>
	);
}

export function initLayout(pageName:string,settingsPageName:string,imageFolder:string|null=null)
{
	const layout = useContext(LayoutContext);
	layout.setPageName(pageName);
	layout.setSettingsPageName(settingsPageName);
	layout.setImageFolder(imageFolder);

	const enableShrink = theme().nav.desktop.settings.enableShrink;
	layout.setExpandDesktopNav(enableShrink);
}

export function useLayout():ILayoutContent
{
	return useContext(LayoutContext);
}

